import { type TriggerV2Record } from "@/shared/domain/triggers";

import styles from "./TriggerFacts.module.css";

/** The identity and audit facts of a trigger, as a two-column list. */
export function TriggerFacts({ record }: { record: TriggerV2Record }) {
  return (
    <dl className={styles.facts}>
      <dt>Name</dt>
      <dd>{record.name}</dd>
      <dt>Trigger ID</dt>
      <dd className={styles.mono}>{record.trigger_id}</dd>
      <dt>Created by</dt>
      <dd>{record.created_by}</dd>
      <dt>Last modified by</dt>
      <dd>{record.modified_by}</dd>
    </dl>
  );
}
